<template>
  <div class="p-postEditor__itemWrapper">
    <div v-if="editingItemIndex !== index" @click="editItem">
      <item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <div class="px-5">
        <codemirror v-model="code" :options="cmOptions" class="my-4" />
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
// language
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'

// theme css
import 'codemirror/theme/elegant.css'

// require active-line.js
import 'codemirror/addon/selection/active-line.js'

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js'
import 'codemirror/addon/search/searchcursor.js'

// hint
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'

// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'

// autoCloseTags
import 'codemirror/addon/edit/closetag.js'

export default {
  name: 'HtmlItem',
  mixins: [itemUtilsMixin],
  data: () => {
    return {
      cmOptions: {
        mode: 'text/html',
        line: true,
        lineNumbers: true,
        collapseIdentical: false,
        highlightDifferences: true,
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: 'elegant',
        autoCloseTags: true,
        hintOptions: {
          completeSingle: false
        },
        autofocus: true
      }
    }
  },
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    },
    code: {
      get () {
        return this.editingItemable.content
      },
      set (value) {
        this.updateEditingItemable(value, 'content')
      }
    }
  }
}
</script>

<style scoped></style>
